import { apiService } from '../_services'

export const industryService = {
  addIndustry,
  getIndustry,
  getIndustryByPage,
  deleteIndustry,
  updateIndustry,
  getIndustryById,
  updateFilters
}

function addIndustry(industry){
  return apiService.fetchAuthPost('industry',industry)
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}
function updateFilters(industryId) {
  return apiService.fetchAuthPost('industry/clear-filter?industryId='+industryId,{} )
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}
function getIndustry(){
  return apiService.fetchAuthGet('industry')
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}
function getIndustryByPage(start, pageSize, search,sectorId) {
  return apiService.fetchAuthGet('industry/page?start=' + start + '&pageSize=' + pageSize + '&search=' + search+(parseInt(sectorId)>0?'&sectorId='+sectorId:''))
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}
function deleteIndustry(id,userId){
  return apiService.fetchAuthPut('industry/delete/'+id+'/'+userId,{})
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}

function getIndustryById(id) {
  return apiService.fetchAuthGet('industry/' + id)
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}
function updateIndustry(industry, id) {
  return apiService.fetchAuthPut('industry/' + id, industry)
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}
